import { useEffect, useState } from "react";

export function Footer({
  apiBaseUrl: _apiBaseUrl,
  pendingQueue,
  flushedAt,
  onFlush,
}: {
  apiBaseUrl: string;
  pendingQueue: number;
  flushedAt: number | null;
  onFlush?: () => void;
}) {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    if (!flushedAt) return;
    const id = window.setInterval(() => setNow(Date.now()), 10_000);
    return () => window.clearInterval(id);
  }, [flushedAt]);
  const flushedAgoSec = flushedAt ? Math.floor((now - flushedAt) / 1000) : null;
  return (
    <div className="px-4 pb-8 pt-4 text-center text-[length:var(--fs-xs)] text-[var(--ink-4)]">
      {pendingQueue > 0 && (
        <div
          role="status"
          className="mb-2 inline-flex items-center gap-2 rounded-full border border-[var(--warn)] bg-[var(--accent-wash)] px-3.5 py-2 text-[length:var(--fs-xs)] font-semibold text-[var(--accent)]"
        >
          ⏳ 未送信 {pendingQueue} 件 (オンライン復帰で自動送信)
          {onFlush && (
            <button
              type="button"
              onClick={onFlush}
              aria-label="今すぐ再送信"
              className="ml-1 min-h-11 cursor-pointer rounded-md border border-[var(--warn)] bg-[var(--bg-raised)] px-2.5 text-[length:var(--fs-sm)] font-bold text-[var(--accent)]"
            >
              今すぐ再送
            </button>
          )}
        </div>
      )}
      {pendingQueue === 0 && flushedAgoSec !== null && flushedAgoSec < 120 && (
        <div className="mb-1.5 text-[length:var(--fs-xs)] font-semibold text-[var(--ok)]">
          ✓ 同期完了 ({flushedAgoSec < 5 ? "たった今" : `${flushedAgoSec}秒前`})
        </div>
      )}
    </div>
  );
}
